const INPUT_PARSER = Object.freeze({
  bool: 'parseBool',
  code: 'parseCode',
  digit: 'parseDigit',
  int: 'parseInteger',
  money: 'parseMoney',
  text: 'parseText',
});

// noinspection JSUnusedGlobalSymbols
export default INPUT_PARSER;
